import { compose, find, prop, map, toPairs } from 'ramda';

import { generateStaticRoutes } from './statics';

const staticPages = compose(
  map(([entryId, { name, path, pageTitle }]) => ({
    name,
    path,
    entryId,
    pageTitle,
  })),
  toPairs
)(generateStaticRoutes());

const allPages = (pages) => [...pages, ...staticPages];

const pageName = (findFn, pages) =>
  compose(prop('name'), findFn, allPages)(pages);

export const pageNameByType = (type, pages) =>
  pageName(
    find((page) => page.entryId === type),
    pages
  );

export const staticPageTitleByType = (type) =>
  find((page) => page.entryId === type)(staticPages)?.pageTitle;
